export enum DossierClientMethodNames {
    PersistedRecordingDownloadTaskStatusChanged = "PersistedRecordingDownloadTaskStatusChanged",
    PersistentRecordingTaskStatistics_DownloadStatus = "PersistentRecordingTaskStatistics.DownloadStatus",
    PersistentRecordingTaskStatistics_ReIdentificationStatus = "PersistentRecordingTaskStatistics.ReIdentificationStatus",
    DossierDeviceStatusChanged = "DossierDeviceStatusChanged",
    DossierInformationChanged = "DossierInformationChanged",
    DossierRemoved = "DossierRemoved",
    PersistedRecordingPersistedStartAndStopTimeChanged = "PersistedRecordingPersistedStartAndStopTimeChanged",
    DossierExportChanged = "DossierExportChanged",
}

export const dossierGroupId = "Dossiers";

export const dossierClientMethodNames = [
    DossierClientMethodNames.PersistedRecordingDownloadTaskStatusChanged,
    DossierClientMethodNames.PersistentRecordingTaskStatistics_DownloadStatus,
    DossierClientMethodNames.PersistentRecordingTaskStatistics_ReIdentificationStatus,
    DossierClientMethodNames.DossierDeviceStatusChanged,
    DossierClientMethodNames.DossierInformationChanged,
    DossierClientMethodNames.PersistedRecordingPersistedStartAndStopTimeChanged,
    DossierClientMethodNames.DossierExportChanged,
    DossierClientMethodNames.DossierRemoved,
];
